import React from "react";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";
import UsedImage from "../../../../assets/images/smartphone.png";
import NewImage from "../../../../assets/images/new_mobile.png";
import { useCreateThaniacelContext } from "../provider/createThaniacel.provider";
import { useCreateNewsThaniacelContext } from "../news/provider/createNewsThaniacel.provider";
import { useCreateUsedThaniacelContext } from "../used/provider/createUsedThaniacel.provider";

const SelectFlowComponent = () => {
  const { setFlow, setStep } = useCreateThaniacelContext();
  const { handleInitialState: handleInitialStateNews } =
    useCreateNewsThaniacelContext();
  const { handleInitialState: handleInitialStateUsed } =
    useCreateUsedThaniacelContext();

  const handleResetState = (flow: string) => {
    setFlow(flow);
    handleInitialStateUsed();
    handleInitialStateNews();
    setStep(5);
  };
  return (
    <div className="flex w-full flex-col items-center justify-center bg-transparent">
      <div className="mt-4 flex h-96 w-full space-x-4">
        <div className="flex h-full w-1/2 flex-col items-center justify-center rounded-xl bg-white px-4 py-2 shadow-xl">
          <div className="flex w-full flex-col items-center justify-center">
            <img src={NewImage} alt="new_mobile" className="my-6 ml-4 w-40" />
            <h2 className="text-buttonBlack text-center text-2xl font-bold">
              Celulares Thaniacel
            </h2>
          </div>
          <PrimaryButton
            title="Seleccionar"
            className={
              "bg-buttonBlack text-whiteSoft mt-5 rounded-3xl px-5 py-1 text-sm font-normal"
            }
            onClick={() => handleResetState("new")}
          />
        </div>
        <div className="flex h-full w-1/2 flex-col items-center justify-center rounded-xl bg-white px-4 py-2 shadow-xl">
          <div className="flex w-full flex-col items-center justify-center">
            <img src={UsedImage} alt="used_mobile" className="my-4 ml-4 w-44" />
            <h2 className="text-buttonBlack text-center text-2xl font-bold">
              Celulares externos
            </h2>
          </div>
          <PrimaryButton
            title="Seleccionar"
            className={
              "bg-buttonBlack text-whiteSoft mt-5 rounded-3xl px-5 py-1 text-sm font-normal"
            }
            onClick={() => handleResetState("used")}
          />
        </div>
      </div>
    </div>
  );
};
export default SelectFlowComponent;
